// import React from 'react';
// import { Link } from 'react-router-dom';
// import { Col, Row } from 'reactstrap';

// const BreadCrumb = ({ title, pageTitle }) => {
//     return (
//         <React.Fragment>
//             <Row>
//                 <Col xs={12}>
//                     <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                         <h4 className="mb-sm-0">{title}</h4>

//                         <div className="page-title-right">
//                             <ol className="breadcrumb m-0">
//                                 <li className="breadcrumb-item"><Link to="#">{pageTitle}</Link></li>
//                                 <li className="breadcrumb-item active">{title}</li>
//                             </ol>
//                         </div>

//                     </div>
//                 </Col>
//             </Row>
//         </React.Fragment>
//     );
// };

// export default BreadCrumb;

import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

const BreadCrumb = ({ title, currentPath = '', onNavigate, pageTitle }) => {
    const parts = currentPath ? currentPath.split('/').filter(Boolean) : [];
    let pathSoFar = '';
    const breadcrumbItems = parts.map((part, index) => {
        pathSoFar += part + '/';
        return {
            name: part,
            path: pathSoFar,
            isLast: index === parts.length - 1,
        };
    });
    return (
        <React.Fragment>
            <Row>
                <Col xs={12}>
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0">{title}</h4>

                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><Link to="#" onClick={() => onNavigate ? onNavigate('') : null}>{pageTitle}</Link></li>
                                {breadcrumbItems.map(item => (
                                    <li
                                        key={item.path}
                                        className={`breadcrumb-item ${item.isLast ? 'active' : ''}`}
                                        aria-current={item.isLast ? 'page' : undefined}
                                    >
                                        {item.isLast ? (
                                            item.name
                                        ) : (
                                            <Link to="#" onClick={() => onNavigate(item.path)}>
                                                {item.name}
                                            </Link>
                                        )}
                                    </li>
                                ))}
                            </ol>
                        </div>

                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default BreadCrumb;